require('./cardTransferMoneyView.scss');
const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @actions
const cardTransferMoneyActions = require('actions/cardTransferMoney');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { TransferMoneyStep1 } = require('components/cards/cardTransferMoneySteps/transferMoneyStep1/transferMoneyStep1');
const TransferMoneyStep2 = require('components/cards/cardTransferMoneySteps/transferMoneyStep2/transferMoneyStep2');
const TransferMoneyFinalStep = require('components/cards/cardTransferMoneySteps/transferMoneyFinalStep/transferMoneyFinalStep');
const CardDetailsSidebar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');
const WizardError = require('components/commons/wizardError/wizardError')
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');

// @utilities
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');
const { getFormattedString } = require('utilities/currencyHelper');
const { PAGE_GENERIC, recordPath } = require('utilities/tagging');

// @constants
const {
    CARD_TRANSFER_MINIMUM_AMOUNT,
    EURO_SYMBOL,
    FIRST_STEP,
    GRAPHIC_TUTOR_TYPE_4,
} = require('constants/index');
const { WEB_INACTIVE_ACCOUNT_ENABLED } = require('constants/flagBasedFeatures');

class CardTransferMoneyView extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
    }

    componentWillMount() {
        const { immCards, match: { params: { cardId } }, getTransferMoneyFromCCToAccountDetails } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        let interventionList = immCard.getIn(['interventionList']);
        let titularPan;
        interventionList.forEach((beneficiary) => {
            if (beneficiary.get('interventionType') === 'TITULAR') {
                titularPan = beneficiary.get('pan')
            }
        })
        getTransferMoneyFromCCToAccountDetails(immCard, titularPan);
    }

    componentDidMount() {
        const { history, immCards, match: { params: { cardId } }, setTotalAvailableBalance } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        AccessHelper.allowAccess(cardConstants.CARD_TRANSFER_MONEY, { immCard }, history);
        setTotalAvailableBalance(immCard.getIn(['availableBalance', 'amount']));

        const tagging = immCard.get('tagging');
        recordPath('tarjeta/dinero-al-instante', PAGE_GENERIC, '', '', tagging);
    }

    componentWillUnmount() {
        this.props.clearRequest();
    }

    buildCardDetailsError() {
        const goBackButtonLabel = formatText('cardTransferMoney-backToCards').toUpperCase();
        const linkToDetails = '/myprofile/cards';
        const mainButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };
        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <WizardError
                    errorMessage={formatText('cardTransferMoney-cardDetailsApiErrorTitle')}
                    mainButton={mainButton}
                >
                    <div className="card-transfer-money-view__error-body">
                        <p className="card-transfer-money-view__error-sub-message">{formatText('cardTransferMoney-cardDetailsApiErrorMessage')}</p>
                    </div>
                </WizardError>
            </div>
        );
    }

    buildErrorWizard(immCard) {
        const goBackButtonLabel = formatText('cardTransferMoney-backToCards').toUpperCase();
        const linkToDetails = '/myprofile/cards';
        const mainButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };
        const minimumAmount = getFormattedString({
            amount: CARD_TRANSFER_MINIMUM_AMOUNT,
            currency: EURO_SYMBOL,
            decimalsLength: 0
        });

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <WizardError
                    errorMessage={formatText('cardTransferMoney-availableBalanceErrorTitle')}
                    mainButton={mainButton}
                >
                    <div className="card-transfer-money-view__error-body">
                        <div className="col-md-5">
                            <CommercialAds path="cards" type="cards" immCard={immCard} />
                        </div>
                        <p className="card-transfer-money-view__error-sub-message col-md-7">{formatText('cardTransferMoney-availableBalanceErrorMessage', [minimumAmount])}</p>
                    </div>
                </WizardError>
            </div>
        );
    }

    buildSuccessful(immCard) {
        const { immCardTransferMoney, immAccounts } = this.props;
        const accountNumberAssociatedwithCard = immCard.getIn(['associatedAccount']).replace(/\s/g, '');
        const immSteps = immCardTransferMoney.get('steps');
        const accountsMap = immAccounts.get('byId');
        const accountsList = immAccounts.get('byOrder');
        let accountsIndexes = [];

        if (accountsList.size > 0) {
            accountsIndexes = this.sortAccounts(accountsList, accountsMap, accountNumberAssociatedwithCard);
        }

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-10">
                <TransferMoneyFinalStep
                    errorState={immCardTransferMoney.get('submitError')}
                    immCard={immCard} immStep={immSteps.get(FIRST_STEP)}
                    immAccounts={accountsMap}
                    accountsIndexes={accountsIndexes}
                />
            </div>
        )
    }

    buildWizard(immCard) {
        const { immAccounts, immCardTransferMoney, immFlagBasedFeatures, validateStep, setVisibleStep, setWillCancel } = this.props;
        const accountsList = immAccounts.get('byOrder');
        const accountNumberAssociatedwithCard = immCard.getIn(['associatedAccount']).replace(/\s/g, '');

        const accountsMap = immAccounts.get('byId');
        const immSteps = immCardTransferMoney.get('steps');
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.handleFinish,
            cancel: this.handleCancel
        };
        let accountsIndexes = [];

        if (accountsList.size > 0) {
            accountsIndexes = this.sortAccounts(accountsList, accountsMap, accountNumberAssociatedwithCard);
        }

        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immCardTransferMoney.get('visibleStep')}
                showPreLeaveModal={true}>
                <WizardStep position="first" cancelButton={true} >
                    <TransferMoneyStep1
                        immCard={immCard}
                        immAccounts={accountsMap}
                        accountsIndexes={accountsIndexes}
                        immStep={immSteps.get(FIRST_STEP)}
                        isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    immFinalButton="cardTransferMoney-transferMoneyFinalButton"
                    addLoadingBehaviour={true}>
                    <TransferMoneyStep2
                        immCard={immCard}
                        immCardTransferMoney={immCardTransferMoney.get('steps').get(0)}
                        immAccounts={accountsMap}
                        accountsIndexes={accountsIndexes}
                    />
                </WizardStep>
            </Wizard>
        )
    }

    handleCancel() {
        const { cardId } = this.props.match.params;

        this.props.history.push(`/myprofile/cards/${cardId}/details`);
    }

    handleFinish() {
        const { match: { params: { cardId } }, immCards, immCardTransferMoney } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        this.props.handleFinish(immCard.get('cardId'), immCardTransferMoney.get('cardDetails'));
    }

    sortAccounts(accountsList, accountsMap, accountNumberAssociatedwithCard) {
        let positiveIndexes = [];

        accountsList.forEach(accountId => {
            const accountFullContractNumber = accountsMap.getIn([accountId, 'ibanComplex', 'codbban']);
            if (accountNumberAssociatedwithCard == accountFullContractNumber) {
                positiveIndexes.push(accountId);
            }
        });

        return positiveIndexes;
    }

    render() {
        const { match: { params: { cardId } }, immCards, immCardTransferMoney } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('tutorials-cardsTransferMoneyTitle')}
            />
        );
        let content;

        if (immCardTransferMoney.get('isFetching')) {
            content = <LoadingSection />;
        } else if (immCard) {
            const titleKey = 'cardTransferMoney-transferMoneyToTheCard';
            const type = immCard.get('type');
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = immCard.get('alias').get('current');
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: immCard.get('alias').get('current'),
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText('cardDetails-transferMoney')
                }
            ];
            let bodyContent;
            const availableBalance = immCard.getIn(['availableBalance', 'amount']);
            if (availableBalance < CARD_TRANSFER_MINIMUM_AMOUNT) {
                bodyContent = this.buildErrorWizard(immCard);
            } else if (immCardTransferMoney.get('getCardDetailsError')) {
                bodyContent = this.buildCardDetailsError()
            }
            else if (immCardTransferMoney.get('submitSuccessful') || immCardTransferMoney.get('submitError')) {
                bodyContent = this.buildSuccessful(immCard);
            } else {
                const wizard = this.buildWizard(immCard);

                bodyContent = (
                    <div className="row">
                        {/* >> CONTENT DUPLICATED: REF-01 */}
                        <div className="col-md-12 hidden-lg grid-view--fix-cell-separation-bottom">
                            <CardDetailsSidebar immCard={immCard} />
                        </div>
                        {/* CONTENT DUPLICATED: REF-01 << */}
                        <div className="col-md-12 col-lg-8">
                            {wizard}
                        </div>
                        {/* >> REF-01 */}
                        <div className="hidden-xs hidden-sm hidden-md col-lg-4">
                            <CardDetailsSidebar immCard={immCard} />
                        </div>
                        {/* REF-01 << */}
                    </div>
                );
            }

            content = (
                <div>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                    tutorial={tutorial}
                                    finalTitle={getFinalTitle(titleKey)}>
                                    <CardHeaderDetails immCard={immCard} />
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative card-transfer-money-view">
                                {bodyContent}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return content;
    }
}

CardTransferMoneyView.propTypes = {
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCardTransferMoney: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    clearRequest: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    setTotalAvailableBalance: PropTypes.func.isRequired,
    getTransferMoneyFromCCToAccountDetails: PropTypes.func.isRequired
};

module.exports.constructor = CardTransferMoneyView;
module.exports.CardTransferMoneyView = connect(
    state => ({
        immAccounts: state.accounts,
        immCards: state.cards,
        immCardTransferMoney: state.cardTransferMoney,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }), {
    validateStep: cardTransferMoneyActions.validateStep,
    setVisibleStep: cardTransferMoneyActions.setVisibleStep,
    setWillCancel: cardTransferMoneyActions.setWillCancel,
    handleFinish: cardTransferMoneyActions.postTransfer,
    clearRequest: cardTransferMoneyActions.clearRequest,
    setTotalAvailableBalance: cardTransferMoneyActions.setTotalAvailableBalance,
    getTransferMoneyFromCCToAccountDetails: cardTransferMoneyActions.getTransferMoneyFromCCToAccountDetails
})(withRouter(CardTransferMoneyView));
